export const ORDER_STATUS = {
  active: { color: 'green', text: '服务中' },
  ended: { color: 'default', text: '已到期' },
  terminated: { color: 'orange', text: '已终止' },
  archived: { color: 'default', text: '已归档' },
  completed: { color: 'purple', text: '已完成' },
  pending: { color: 'blue', text: '待办理' },
  cancelled: { color: 'error', text: '已取消' }
} as const
